import { render, staticRenderFns } from "./tran.vue?vue&type=template&id=68c25750&scoped=true&"
import script from "./tran.vue?vue&type=script&lang=js&"
export * from "./tran.vue?vue&type=script&lang=js&"
import style0 from "./tran.vue?vue&type=style&index=0&id=68c25750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c25750",
  null
  
)

export default component.exports